import React, { Component,createRef  } from "react";
import SelectDropDown from '../../selectdropdown/SelectDropDown'
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row,Image } from "react-bootstrap";
import moment, { invalid } from "moment";
import DateTime from 'react-datetime'
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import '../_feeStructure.scss';



const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class FeeReportDateWise extends Component {
    constructor(props) {
        super(props)
        this.printRef = createRef();
        this.state = {
            dataClear: 0,
            paidSelectedData:"",
            paidSelectedDataVal:"",
            validateDate:"",
            receiptDetailsArr:[],
            paidDatesAreAvailable:[],
            svgData:""
        }
    };

    componentDidUpdate() {
       
        if (this.props.show === true && this.state.dataClear == 0) {
            var checkDatesArr=[];
            if(this.props.studentPaymentData.length>0){
                for(var i in this.props.studentPaymentData){
                    for(var j in this.props.studentPaymentData[i].terms){
                        if( this.props.studentPaymentData[i].terms[j].is_paid == 1){
                            console.log("pppppppppp",moment.unix(this.props.studentPaymentData[i].terms[j].paid_date).format('DD-MM-YYYY'));
                        var newObj1={
                                label:moment.unix(this.props.studentPaymentData[i].terms[j].paid_date).format('DD-MM-YYYY'),
                                value:moment.unix(this.props.studentPaymentData[i].terms[j].paid_date).format('DD-MM-YYYY')
                            }
                            checkDatesArr.push(newObj1);
                        }
                        
                        
                    }
                }
            }

            this.setState({
                dataClear: 1,
                paidSelectedData: "",
                paidSelectedDataVal: "",
                receiptDetailsArr:[],
                svgData:""
            });

            if(checkDatesArr.length>0){
                this.setState({paidDatesAreAvailable:checkDatesArr})
            }else{
                this.setState({paidDatesAreAvailable:[]})
            }
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
            
    }

    handleGeneratePdf =  () => {

        const input = this.printRef.current;
        html2canvas(input, { scale: 2,useCORS:true}).then((canvas) => {
          
          const imgData = canvas.toDataURL('image/png');
          
          const pdf = new jsPDF('p', 'mm', 'a4');
          const imgWidth = 210; // A4 width in mm
          const pageHeight = 295; // A4 height in mm
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;
          let position = 15;
    
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
    
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
    
          pdf.save('document.pdf');
        });


      };

dropDownGetValuesNew = () => {
    console.log("ddddddddd","ok")
    if(this.props.studentPaymentData.length>0){
        let getArray = [];
        var newObj1 = {
            value: "",
            label: "Select Date"
        };
        getArray.push(newObj1);
    
        console.log("ccccc",this.props.studentPaymentData)

        for(var i in this.props.studentPaymentData){
            for(var j in this.props.studentPaymentData[i].terms){
                if(this.props.studentPaymentData[i].terms[j].is_paid == 1){
                    newObj1={
                        label:moment.unix(this.props.studentPaymentData[i].terms[j].paid_date).format('DD-MM-YYYY'),
                        value:moment.unix(this.props.studentPaymentData[i].terms[j].paid_date).format('DD-MM-YYYY')
                    }
                    getArray.push(newObj1);
                    //this.setState({paidSelectedDataArr:getArray})
                }
                
                
            }
        }

        const uniqueArray = getArray.filter((value, index) => {
            const _value = JSON.stringify(value);
            return index == getArray.findIndex(obj => {
            return JSON.stringify(obj) == _value;
            });
        });

        return uniqueArray;
    }
    
};

    selecthandleInputChange = (ename, evalue) => {
        const name = ename;
        const value = evalue;

        var datesArr=[];

        if(this.props.studentPaymentData !=undefined && this.props.studentPaymentData.length>0){
            for(var i in this.props.studentPaymentData){
                for(var j in this.props.studentPaymentData[i].terms){
                    if(this.props.studentPaymentData[i].terms[j].is_paid == 1){
                        var newObj1={
                            label:moment.unix(this.props.studentPaymentData[i].terms[j].paid_date).format('DD-MM-YYYY'),
                            value:moment.unix(this.props.studentPaymentData[i].terms[j].paid_date).format('DD-MM-YYYY')
                        }
                        datesArr.push(newObj1);
                    }
                    
                    
                }
            }
        }

       if(datesArr.length>0){
        let dateSelectedVal = datesArr.find((a) => a.value == value);
            this.setState({
                paidSelectedDataVal: {
                    value: dateSelectedVal.value,
                    label: dateSelectedVal.label
                },
                paidSelectedData: dateSelectedVal.label,

            })
       }
        
            
    }

    toDataURL = url => fetch(url)
    .then(response => response.blob())
    .then(blob => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  }))

    getDateWisePDFReportNew = async () => {

        if(this.state.paidSelectedData == ""){
            this.setState({validateDate:"Please Select Date"});
            return;
        }

        var detailsArr=[];
        var fee_type_amount_arr=[];
        const { getOrganisationProfile,studentName,examName,studentPaymentData,class_name,globals,getPaymentModes,roll_no, stateData} = this.props;
        const { logo, organisation_name } = getOrganisationProfile;
        const branchWiseData = getOrganisationProfile.branch_wise_data
        const address = branchWiseData.filter((a)=> a.branch_id == stateData.row_branch_id)
        const complete_address = address[0].branch_wise_address
        const image = `https://admin.rizee.in/files/${logo}`;
        this.setState({logo:image});


        this.toDataURL(image)
        .then(dataUrl => {
            console.log("dataUrl",dataUrl)
            this.setState({svgData:dataUrl})
            
        });

        console.log("globals",this.state.svgData)

        var fee_Names={};
        var fee_payment_modes_names={};
        var receiptDate="";
        var totalAmount=0;

        for(var i in globals.offlineFeeTypes){
            
            Object.assign(fee_Names, {[globals.offlineFeeTypes[i].id]:globals.offlineFeeTypes[i].fee_type});
        }

        for(var i in getPaymentModes){
            
            Object.assign(fee_payment_modes_names, {[getPaymentModes[i].id]:getPaymentModes[i].payment_mode});
        }

        console.log(fee_Names)


        if(studentPaymentData !=undefined && studentPaymentData.length>0){
            for(var i in studentPaymentData){
                for(var j in studentPaymentData[i].terms){
                    if(studentPaymentData[i].terms[j].is_paid == 1){
                        if(this.state.paidSelectedData == moment.unix(this.props.studentPaymentData[i].terms[j].paid_date).format('DD-MM-YYYY')){
                            const payment_nameNew =  this.props.getPaymentModes.find(item => item.id == studentPaymentData[i].terms[j].payment_mode_id)

                            var payObj={
                                    fee_type_id:studentPaymentData[i].fee_type_id,
                                    amount:studentPaymentData[i].terms[j].term_amount,
                                    fee_type_name:fee_Names[studentPaymentData[i].fee_type_id],
                                    payment_mode_id:studentPaymentData[i].terms[j].payment_mode_id,
                                    payment_name:payment_nameNew.payment_mode
                                }

                                fee_type_amount_arr.push(payObj)
                        }

                        
                        
                        
                    }
                    
                    
                }
            }

            var dateSplit = this.state.paidSelectedData.split("-");

            receiptDate = Cookies.get("institutionid")+dateSplit[0]+dateSplit[1]+dateSplit[2].toString().substr(-2)

            

            for(var i in fee_type_amount_arr){
                totalAmount = totalAmount+parseInt(fee_type_amount_arr[i].amount)
            }


            var obj={
                "logo":image,
                "organisation_name":organisation_name,
                "complete_address":complete_address,
                "payment_mode":fee_type_amount_arr[0].payment_name,
                "examName":examName,
                "class_name":class_name,
                "studentName":studentName,
                "roll_no":roll_no,
                "date":this.state.paidSelectedData,
                "institute_id":receiptDate,
                "totalAmount":totalAmount,
                "paymentTypeDetails":fee_type_amount_arr
            }

            detailsArr.push(obj);
            this.setState({receiptDetailsArr:detailsArr})

            console.log(detailsArr)
        }else{
            this.setState({receiptDetailsArr:[]})
        }

    }

   

    render() {

       console.log("rowData", this.props.stateData);
       
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Date Wise Fee Structure</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">

                    {
                        this.state.paidDatesAreAvailable.length > 0 ?
                        (
                            <>
                            <Row>
                                <Col sm={4}>
                                <h6 className="font-weight-bold">Select Date <span style={{color:"red",fontSize:"14px"}}>*</span> <span style={{color:"red",fontSize:"12px"}}>{this.state.validateDate}</span></h6>
                                <SelectDropDown
                                    stateData={this.state.paidSelectedDataVal}
                                    handleChange={this.selecthandleInputChange}
                                    name="paidSelectedData"
                                    options={this.dropDownGetValuesNew()}
                                    placeholderName={'Select Date'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                                </Col>
                                <Col sm={3}>
                                    <Button  type="button"  className="btn btn-sm btn-success mt-4" style={{cursor:"pointer"}} onClick={() => this.getDateWisePDFReportNew()}>
                                    GET REPORT
                                    </Button>
                                </Col>
                                
                            </Row>

                            
                            {
                                this.state.receiptDetailsArr.length > 0 ?
                                (
                                    this.state.receiptDetailsArr.map((item,index) => {
                                        return(
                                            <>
                                            <Row>
                                                <Col>
                                                <button type="button" class="btn btn-sm btn-success float-right" onClick={this.handleGeneratePdf}>Generate PDF</button>
                                                </Col>
                                            </Row>
                                            <Row className="justify-content-center mt-3" ref={this.printRef}>
                                                
                                                <Col sm={12}>
                                                    <div className="border_pad">
                                                            {
                                                                item.organisation_name == "Vishra Academy" ?
                                                                (
                                                                    <>
                                                                    <svg width="80%"  xmlns="http://www.w3.org/2000/svg">
                                                                            <image href={this.state.svgData} class="w-100" style={{height:"150px"}}/>
                                                                        </svg>
                                                                        </>
                                                                )
                                                                :
                                                                (
                                                                    <>
                                                                    <svg width="100%" viewBox="0 0 50 15"  xmlns="http://www.w3.org/2000/svg">
                                                                            <image href={this.state.svgData} class="w-100"/>
                                                                        </svg>
                                                                        </>
                                                                )
                                                            }
                                                             
                                                        
                                                        {/*<h6 className="text-center mt-2 fw-bold color_blue_new">{item.organisation_name}</h6>*/}
                                                        <p style={{fontSize:"14px",lineHeight:"23px !important;"}} className="mt-2 text-center">
                                                            {item.complete_address}
                                                        </p>
                                                        <hr className="border_top_clr"/>
                                                        <Row>
                                                            <Col sm={12}>
                                                                <h6 style={{marginLeft:"10px"}}><span className="font-weight-normal">Date</span> : <b>{item.date}</b></h6>
                                                                <div className="flex-block-fee mt-3">
                                                                    <div>
                                                                        <h6 className="mt-2"><span className="font-weight-normal">Receipt No</span> : <b>{item.institute_id}</b></h6>
                                                                        <h6 className="mt-3"><span className="font-weight-normal">Payment Mode</span> : <b>{item.payment_mode != undefined ? item.payment_mode : ""}</b></h6>
                                                                        
                                                                    </div>
                                                                    <div>
                                                                        <h6 ><span className="font-weight-normal">Student Name</span> : <b>{item.studentName}</b></h6>
                                                                        <h6 className="mt-3"><span className="font-weight-normal">Admission No</span> : <b>{item.roll_no}</b></h6>
                                                                    </div>
                                                                    <div>
                                                                        <h6><span className="font-weight-normal">Course</span> : <b>{item.examName}</b></h6>
                                                                        <h6 className="mt-3"><span className="font-weight-normal">Class </span> : <b>{item.class_name}</b></h6>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            </Row>
        
                                                            <Row className="justify-content-center mt-3">
                                                                <Col sm={7}>
                                                                    <div className="table-responsive">
                                                                        <table className="table table-bordered table_custom_css">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>S:No</th>
                                                                                    <th>Particulars</th>
                                                                                    <th>Amount</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    item.paymentTypeDetails.map((payval,indexVal)=>{
                                                                                        return(
                                                                                            <tr>
                                                                                                <td>{indexVal+1}</td>
                                                                                                <td>{payval.fee_type_name}</td>
                                                                                                <td>{payval.amount}</td>
                                                                                            </tr>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </tbody>
                                                                            <tfoot>
                                                                                <tr>
                                                                                    <td colspan="2">Total</td>
                                                                                    <td >{item.totalAmount}</td>
                                                                                </tr>
                                                                            </tfoot>
                                                                        </table>
                                                                    </div>
                                                                </Col>
                                                            </Row>
        
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <div className="float-right" style={{marginRight:"10px"}}>
                                                                        <br/>
                                                                        <h6>Authorized Sign</h6>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            
                                                    </div>
                                                </Col>
                                            </Row>
                                            </>                                    
        
                                        )
                                    })
                                    
                                )
                                :
                                ("")
                            }
                            </>
                        )
                        :
                        (
                            <Row>
                                <Col>
                                    <h6 className="text-center f-14">No Data Available</h6>
                                </Col>
                            </Row>
                        )
                    }
                   

                    
                </Modal.Body>
            </Modal>
        );
    }
};
export default withRouter(FeeReportDateWise);